import { PageRef } from '../core/core.module';
import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { EventCodes, LocalStorageCodes } from '../core/codes';
import { Utils } from '../providers/utils';
import { Facebook } from 'ionic-native';
import { FirebaseData } from '../providers/firebase-data';
import { Observable } from 'rxjs/Observable';
import { Storage } from '@ionic/storage';

import firebase from 'firebase';

declare var window: any;

@Injectable()
export class UserData {
  public realtimeDb: any;
  
  constructor(
    private events: Events, 
    private firebaseData: FirebaseData,
    private storage: Storage,
    public pageRef: PageRef,
    ) {
    this.realtimeDb = firebase.database();
  }

  // Private Methods 

  private loginSuccess(user, nav?, route?) {
    this.storage.set(LocalStorageCodes.HAS_LOGGED_IN, JSON.stringify(true));

    this.setUser(user);
    console.log("Prepare to publish event");
    this.events.publish(EventCodes.USER_LOGIN);
    console.log("pass publishing user_login");
    if(nav && route && route !== ''){
      nav.setRoot(this.pageRef.get(route));
    }
  }

  private loginError(error){
    console.log(error);
    this.events.publish(EventCodes.USER_LOGIN_ERROR, error);
  }

  public setUser(user) {
    // Get User Details
    this.getUserDetails(user.uid).subscribe(fullUser=>{
      let userInfo: any;

      if(fullUser){
        userInfo = fullUser;
      }else{
        userInfo = {
          "uid": user.uid,
          "displayName": user.displayName,
          "photoURL": user.photoURL,
          "email": user.email,
          "providerData": {
            "uid": user.providerData[0].uid,
            "providerId": user.providerData[0].providerId
          }
        }
      }

      userInfo.uid = user.uid || userInfo.uid;
      userInfo.displayName = user.displayName || userInfo.displayName;
      userInfo.photoURL = user.photoURL || userInfo.photoURL || '';
      userInfo.email = user.email || userInfo.email;
      
      // console.log("newUser Info");
      // console.log(userInfo);
      this.storage.set(LocalStorageCodes.CURRENT_USER, JSON.stringify(userInfo));

      // Set Userdata to Firebase Realtime Database
      this.firebaseData.setUserData(user.uid, userInfo);

      this.storage.set(LocalStorageCodes.HAS_LOGGED_IN, JSON.stringify(true));
      console.log("Prepare to publish event");
      this.events.publish(EventCodes.USER_LOGIN);
      console.log("pass publishing user_login");
    });
  }

  //Public Methods
  public getUserDetails(userId){
    var self = this;
    return Observable.create((observer) =>{
        self.realtimeDb.ref('users/' + userId).once('value', data => {
            observer.next(data.val());
        });
    });
  }
  public webFacebookLogin(){
    let provider = new firebase.auth.FacebookAuthProvider();
    provider.setCustomParameters({
      'display': 'popup'
    });
  }
  public facebookLogin(isWeb?:boolean, nav?, route?){
    let self = this, facebookAuth:any;
    if(isWeb){
      let provider = new firebase.auth.FacebookAuthProvider();
      facebookAuth =  firebase.auth().signInWithPopup(provider).then(result=>{
        result.authResponse  = {
          accessToken: result.credential.accessToken
        };
        return result;
      });
    }else{
      facebookAuth = new Promise((resolve, reject) => {
        Facebook.login(["public_profile", "email", "user_friends"])
        .then(userData => resolve(userData), err => reject(err));
      });
    }

    facebookAuth.then(uData => {
      console.log(uData);
      let userData:any = uData;
      if (userData.authResponse) {
        // User is signed-in Facebook.
        // firebase.auth().onAuthStateChanged(firebaseUser => {
        //    // Check if we are already signed-in Firebase with the correct user.
        //   if (!self.isUserEqualFb(userData.authResponse, firebaseUser)) {
            console.log("Pass isUser Equal. Creating user");
            // Build Firebase credential with the Facebook auth token.
            let credential = (<any>firebase.auth.FacebookAuthProvider).credential(userData.authResponse.accessToken);
            // Sign in with the credential from the Facebook user.
            firebase.auth().signInWithCredential(credential).then(function(result){
              console.log("Broadcast login successful");
              self.loginSuccess(result, nav, route);
            }, function(error){
              self.loginError(error);
            });
        //    } else {
        //      console.log("User is already signed-in Firebase (Firebase) with the correct user.");
        //    }
        // });
      } else {
        console.log("User is signed-out of Facebook.");
        firebase.auth().signOut();
      }
    }, function(msg){
      console.log("Error! Signout of Facebook.");
      console.log(msg);
      self.logout();
    });    
  }

  public googleLogin(isWeb?:boolean){
    let self = this, goAuth:any;
    if(isWeb){
      let provider = new firebase.auth.GoogleAuthProvider();
      goAuth =  firebase.auth().signInWithPopup(provider).then(result=>{
        result.authResponse  = {
          accessToken: result.credential.accessToken
        };
        return result;
      });
    }
    else{
      window.plugins.googleplus.login({}, 
        function(userData){
          // firebase.auth().onAuthStateChanged(firebaseUser => {
          //   // Check if we are already signed-in Firebase with the correct user.
          //   if (!self.isUserEqualGoogle(userData, firebaseUser)) {
              console.log("Pass isUser Equal. Creating user");
              
              let credential = (<any>firebase.auth.GoogleAuthProvider).credential(userData.idToken);
              // Sign in with credential from the Google user.
              firebase.auth().signInWithCredential(credential).then(function(result){
                console.log("Successful logged in. Updating missing profile");
                
                result.updateProfile({
                  displayName: userData.displayName,
                  photoURL: userData.imageUrl
                }).then(function(){
                  console.log("Finish updating profile. Broadcast login successful");
                  self.loginSuccess(result);
                }, function(error){
                  self.loginError(error);
                });

              },function(error) {
                self.loginError(error);
              });
           //  }else {
           //    console.log("User is already signed-in Firebase (Google) with the correct user.");
           // }
         // });
      }, function(msg){
        console.log("Error! Signout of Google.");
        console.log(msg);
        self.logout();
      }); 
    }
  }

  public login(email, password){
    let self = this;
    return Observable.create((observer) => {
      firebase.auth().signInWithEmailAndPassword(email, password).then(function(user){
        self.loginSuccess(user);
        observer.next({success: true, user: user});
      }, function(error){
        self.loginError(error);
        observer.next({success: false, error: error});
      })
    });
  }

  public signup(name, email, password){
    let self = this;
    return Observable.create((observer) => {
      firebase.auth().createUserWithEmailAndPassword(email, password).then(function(user){
        user.updateProfile({
          displayName: name,
          photoURL: null
        }).then(function(){
          self.loginSuccess(user);
          observer.next(user)
        }, function(error){
          self.loginError(error);
          observer.next({success:false, message: error});
        });
      }, function(error){
        self.loginError(error);
        observer.next({success:false, message: error});
      })
    });    
  }

  public logout(){
    return Observable.create((observer) => {
      firebase.auth().signOut();
      this.storage.set(LocalStorageCodes.HAS_LOGGED_IN, JSON.stringify(false));
      this.storage.remove(LocalStorageCodes.CURRENT_USER);
      this.events.publish(EventCodes.USER_LOGOUT);

      observer.next(true);
    });
  }

  public getUser() {
    return Observable.create((observer) => {
      this.storage.get(LocalStorageCodes.CURRENT_USER).then((value) => {
        observer.next(value ? JSON.parse(value) : null);
      });
    });
  }

  public hasLoggedIn() {
    return Observable.create((observer) => {
      this.storage.get(LocalStorageCodes.HAS_LOGGED_IN).then((value) => {
        observer.next(value ? JSON.parse(value) : false);
      }).catch(error =>{
        observer.next(false);
      });
    });
  }

  public getUserNameInitials() {
    return Observable.create((observer) => {
      this.storage.get(LocalStorageCodes.CURRENT_USER).then((value) => {
        if(!value || !JSON.parse(value).displayName){
          observer.next("");
        }else{
          observer.next(Utils.getFirstInitials(JSON.parse(value).displayName));
        }
      });
    });
  }
  public sendPasswordResetEmail(emailAddress){
    return Observable.create((observer)=>{
      firebase.auth().sendPasswordResetEmail(emailAddress).then(function(res){
        console.log('sendPassword');
        console.log(res);
        observer.next({success: true});
      }, function(error){
        console.log(error);
        observer.next({success: false, msg: error.message});
      })
    })
  }

}

 


// WEBPACK FOOTER //
// ./src/providers/user-data.ts